<template>
    <DCard
        padding
    >
        <div
            v-for="(items, index) in smsTemplates"
            :key="index"
        >
            <h3>{{ __(`tools.sms.categories.${index}`) }}</h3>
            <DTable
                :items="items"
                :fields="fields"
                hover
                class="sample-table"
            >
                <template #name="{item}">
                    <td>
                        {{ __(`tools.sms.templates.${item.type}.name`) }} <br>
                        <span class="text-muted fst-italic">
                            {{ __(`tools.sms.templates.${item.type}.description`) }}
                        </span>
                    </td>
                </template>
                <template #actions="{item}">
                    <td class="actions">
                        <DButton
                            icon="pencil"
                            mini
                            class="ms-2"
                            @click="editSample(item)"
                        />
                    </td>
                </template>
            </DTable>
        </div>
    </DCard>
</template>

<script setup>
import { __ } from '~@/Composables/translation'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

defineProps({
    brands: {
        type: Array,
        default: () => { return [] }
    },
    smsTemplates: {
        type: Object,
        default: () => { return {} }
    }
})

const fields = [
    { key: 'name', label: __('tools.sms.table.name') },
    { key: 'actions', label: '', sorter: false, filter: false }
]

const editSample = (item) => router.get(route('tools.sms-templates.flavours', { smsType: item.type }))
</script>

<style scoped>
.emails-table .table-responsive {
    overflow: inherit !important;
}
.sample-table tr td:nth-child(2),
.sample-table thead tr th:nth-child(2) {
    text-align: right;
}
.actions{
    display: flex;
    justify-content: flex-end;
}
</style>
